module.exports = __webpack_public_path__ + "master-logo.1a3d1a78.svg";